(function () {
  angular.module("akitabox.ui.dialogs.room.delete", [
    "akitabox.core.constants",
    "akitabox.core.services.flag",
    "akitabox.core.services.organization",
    "akitabox.core.services.room",
    "akitabox.core.toast",
  ]);
})();
